<template>
    <div>
        <serviceitem-dialog-selector
            v-model="dialogVisible"
            :selectId="checkedKeys[0]"
            :multiple="multiple"
            :showTimes="showTimes"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :default-checked-keys="checkedKeys"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
        </serviceitem-dialog-selector>
    </div>
</template>
<script>
import UtilsMixins from '@/mixins/utils'
import ServiceitemDialogSelector from './serviceitem-dialog-selector.vue'
export default {
    name: 'serviceitemDialogSelectorInstance',
    mixins: [UtilsMixins],
    components: {
        ServiceitemDialogSelector,
    },
    data() {
        return {
            dialogLoading: false,
            defaultCheckedKeys: [],
            dialogVisible: false,
            selectorData: null,
            sidebarData: null,
            multiple: true,
            title: undefined,
            showTimes: false,
        }
    },
    computed: {
        checkedKeys() {
            const idList = this.defaultCheckedKeys.length ? this.defaultCheckedKeys : (this.selectListData ? this.selectListData.map(item => item.no) : []);
            return  idList;
        }
    },
    methods: {
        show(params) {
            const { loadData, defaultCheckedKeys, multiple , title, showTimes } = params;
            if (multiple !== undefined) {
                this.multiple = multiple;
            }
            if (showTimes !== undefined) {
                this.showTimes = showTimes;
            }
            this.title = title || '请选择项目';

            this.defaultCheckedKeys = defaultCheckedKeys;
            if (loadData) {
                this.dialogLoading = true;
                loadData(this.loadDataCallback);
            }
            this.dialogVisible = true;
        },
        onConfirm(data, shortcutValue) {
            this.resolve({
                selectValue: data,
                shortcutValue,
            });
        },
        onSelectItem(data) {
            this.resolve(data);
        },
        loadDataCallback(serviceItemList) {
            const listData = serviceItemList.filter(classItem => {
                const { serviceItems, classid } = classItem;
                if (serviceItems && serviceItems.length) {
                    classItem.serviceItems = serviceItems.map(item => {
                        item.classid = classid;
                        return item;
                    })
                }
                classItem.itemid = classid;
                return classItem.serviceItems && classItem.serviceItems.length
            });
            const sidebarListData = [{
                itemid: -1,
                name: '全部',
                classid: -1,
            }, ...listData];
            this.dialogLoading = false;
            this.selectorData = listData;
            this.sidebarData = sidebarListData;
        },
    }
}
</script>